<template>
  <div id="app">
    <CiLoader :isPageLoader="true" v-if="pageLoader"/>
    <div v-else>
      <aside
        class="aside d-print-none"
        ref="aside"
        :class="{ active: showBookingDetails }"
      >
        <router-view name="aside" :key="$route.path"></router-view>
      </aside>
      <main
        class="main"
        :class="{ detailsActive: showBookingDetails, 'no-scroll': loader }"
      >
        <router-view name="main"></router-view>
      </main>
      <div
        class="overlay"
        :class="{ active: showBookingDetails }"
        @click="toggleBookingDetails"
      ></div>

      <CiLoader :isPageLoader="false" v-if="loader"/>      

      <ci-cookie-layer v-if="showCookieLayer"/>

      <vue-progress-bar></vue-progress-bar>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { CiCookieLayer, CiLoader } from './components'
import { loadPartnerCss } from './utils/partnerCss'

export default {
  name: 'App',
  components: {
    CiCookieLayer,
    CiLoader
  },
  data() {
    return {
      showCookieLayer: true
    }
  },
  created() {
    
    if (this.aid) {
      loadPartnerCss(this.aid)
    }
    if (this.aid === window._ci_aid){
      this.showCookieLayer = false
    }
  },
  computed: {
    ...mapGetters('application', {
      loader: 'loader',
      showBookingDetails: 'showBookingDetails',
      pageLoader: 'pageLoader',
    }),
    ...mapGetters('booking', {
      aid: 'aid',
    }),
  },
  methods: {
    ...mapActions('application', {
      toggleBookingDetails: 'toggleBookingDetails',
    }),

    addNoScrollClasses() {
      document.body.classList.add('no-scroll')
      document.documentElement.classList.add('no-scroll')
    },

    removeNoScrollClasses() {
      document.body.classList.remove('no-scroll')
      document.documentElement.classList.remove('no-scroll')
    },

    onShowBookingDetails(isOpen) {
      isOpen ? this.addNoScrollClasses() : this.removeNoScrollClasses()
    },
  },
  watch: {
    showBookingDetails: {
      handler: 'onShowBookingDetails',
      immediate: true,
    },
  },
}
</script>
<style lang="css" src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
@import '~bootstrap/scss/bootstrap-reboot';
@import '~bootstrap/scss/bootstrap-grid';
@import '~bootstrap/scss/utilities';
@import 'general';

html,
body {
  font-size: 16px;
  overflow-y: visible;

  &.no-scroll {
    overflow: hidden;
  }
}

body {
  backface-visibility: hidden;
  min-height: 100vh;
  background: #f5f5f5;
}

html {
  box-sizing: border-box;
}

#app {
  @include font('gotham_bookregular');

  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  color: $primary-font-color;
  margin: 0 auto;
  max-width: 1400px;
  position: relative;
  width: 100%;
  min-height: 100vh;
}

.main {
  min-height: 100vh;

  &.detailsActive {
    overflow: hidden;

    @include media-breakpoint-up(md) {
      height: auto;
      overflow: visible;
    }
  }

  &.no-scroll {
    height: 100vh;
    overflow: hidden;
  }
}

.aside {
  background: white;
  box-shadow: none;
  height: 100%;
  left: 0;
  overflow: hidden;
  position: fixed;
  top: 0;
  transform: translate3d(0, 100%, 0);
  transition: transform 0.4s cubic-bezier(0.37, 0.01, 0, 0.98);
  width: 100%;
  z-index: 100;

  &.active {
    box-shadow: 1px 2px 4px 5px rgba(0, 0, 0, 0.1);
    transform: translate3d(0, 0, 0);
  }

  @include media-breakpoint-up(lg) {
    min-width: 670px;
    transform: translate3d(-100%, 0, 0);
    width: 60%;
  }
}

.overlay {
  background: white;
  height: 0;
  left: 0;
  opacity: 0;
  position: fixed;
  top: 0;
  transition: opacity 0.4s cubic-bezier(0.37, 0.01, 0, 0.98);
  width: 100%;

  &.active {
    height: 100%;
    opacity: 0.7;
    transition: opacity 0.4s cubic-bezier(0.37, 0.01, 0, 0.98);
    width: 100%;
    z-index: 50;
  }
}


h1,
h2,
h3 {
  @include font('gotham_mediumregular');
}

.white-box {
  background: white;
  border-radius: 4px;
  border: 1px solid rgba(155, 155, 155, 0.5);
  box-shadow: 0 2px 23px 0 #ededed;
  overflow: hidden;
  position: relative;
}

.clickable {
  cursor: pointer;
}

.meta__description {
  * {
    margin: 0;
    padding: 0;
  }
}
</style>
